import { render, staticRenderFns } from "./drawer-user.vue?vue&type=template&id=6d76aefe&"
import script from "./drawer-user.vue?vue&type=script&lang=js&"
export * from "./drawer-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "drawer-user.vue"
export default component.exports